export default "__VITE_ASSET__MFcl20mC__"